import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Copyright from './CopyRight';

export default function Footer() {
    return (
        <Box
            sx={{
                bgcolor: 'customLight.main',
                p: 3,
                boxShadow: 8,
            }}
            component="footer"
        >
            <Copyright />
            <Typography
                variant="subtitle1"
                align="center"
                color="customText.main"
                component="p"
            >
                Designed by Shz Lee
            </Typography>
        </Box>
    );
}